<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { InfoPageData } from './+data'
import { useData } from 'vike-vue/useData'
import { useFormatSeoContent } from '@/composables/useFormatSeoContent'
import { useGtmOnPageMounted } from '@/composables/useGtmTag'

const { t } = useI18n()

const data = useData<InfoPageData>()
useFormatSeoContent(data.page.seoTitle, data.page.hero.subtitle)
useGtmOnPageMounted('other')

const breadcrumb = {
  ariaLabel: t('breadcrumb.ariaLabel'),
  items: [
    { text: t('page.accueil'), to: '/' },
    {
      text:
        data.page?.breadcrumbTitle && data.page.breadcrumbTitle.length > 40
          ? `${data.page?.breadcrumbTitle.slice(0, 40)}...`
          : data.page?.breadcrumbTitle,
    },
  ],
}
</script>

<template>
  <div
    v-if="data.page"
    class="Page"
  >
    <molecules-ui-breadcrumb v-bind="breadcrumb" />
    <organisms-ui-hero v-bind="data.page.hero" />
    <div class="container my-8">
      <molecules-ui-rich-text :content="data.page.content" />
    </div>
  </div>
</template>
